import React, { useEffect, useRef, useState } from "react";
// redux
import { useDispatch } from "react-redux";
import { getInstance } from "../../../../../../actions";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import ReadingAttribution from "../components/ReadingAttribution";
import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";

export default function PEReferenceReading(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();
  const dispatch = useDispatch();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  const [reading, setReading] = useState(null);

  // get data from API on page load
  const getReading = async () => {
    try {
      const response = await dispatch(
        getInstance("pages")(data.material)
      ).unwrap();
      setReading(response);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getReading();
  }, [data]);

  return (
    <div>
      <Typography className="text-16 font-bold p-16 pb-0">
        Page Instructions:
      </Typography>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      <Paper
        elevation={0}
        variant="outlined"
        square
        className="p-16 pb-32 m-16"
      >
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Typography className="text-16 font-bold m-0">Reading:</Typography>
          </Grid>
          <Grid item xs={12}>
            {reading ? (
              <ReadingAttribution
                attribution={reading.content.core}
                tl={tl}
                dir={dir}
              />
            ) : (
              <p>Reading not found...</p>
            )}
          </Grid>
        </Grid>
      </Paper>

      {data.core.map((question, index) => (
        <Paper
          key={index}
          elevation={0}
          variant="outlined"
          square
          className="m-16"
        >
          <Typography className="text-16 font-bold px-16 pb-0">
            Question {index + 1}
          </Typography>

          <Paper elevation={0} variant="outlined" square className="p-16 mx-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      Prompt:
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={`${tl} m-0`} dir={dir}>
                      {question.prompt}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 mx-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      Schoolhouse Response:
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className="text-14 m-0">
                      Paragraph {question.start_paragraph}: Sentence{" "}
                      {question.start_second} - Paragraph{" "}
                      {question.end_paragraph}: Sentence {question.end_second}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 mx-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      Feedback:
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: question.feedback }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Paper>
      ))}
    </div>
  );
}
